import type { ChatWootConfig } from '../components/chat/types';
import { configLoader } from '@/utils/configLoader';

const logConfig = (config: ChatWootConfig) => {
  console.group('ChatWoot Configuration');
  console.log('ChatWoot:', {
    enabled: config.enabled,
    websiteToken: config.enabled ? '***' + config.websiteToken.slice(-4) : 'disabled',
    baseUrl: config.baseUrl
  });
  console.groupEnd();
};

export const getChatConfig = (): ChatWootConfig => {
  const config: ChatWootConfig = {
    enabled: false, // Temporarily disabled
    websiteToken: configLoader.getValue('CHATWOOT_WEBSITE_TOKEN', 'CHATWOOT_WEBSITE_TOKEN'),
    baseUrl: configLoader.getValue('CHATWOOT_BASE_URL', 'https://app.chatwoot.com')
  };
  
  // Log the configuration when it's retrieved
  logConfig(config);
  return config;
}; 